exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-link {\n  padding-left: 0px; }\n\n.card-body .col-form-label {\n  padding-top: 0px;\n  padding-left: 10px; }\n\nlabel.col-form-label.switch .switch-handle {\n  margin-top: calc(0.375rem + 1px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-consultant/form-consultant.component.scss
// module id = ../../../../../src/app/components/form-consultant/form-consultant.component.scss
// module chunks = main